module.exports = __webpack_public_path__ + "static/media/logo.b65a3682.svg";